var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFeeds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,44.9h-4v-1.77H8v1.77H4v-3.77c0-1.11,.9-2,2-2H42c1.1,0,2,.89,2,2v3.77Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,8.87H6c-1.1,0-2-.89-2-2V3.1h4v1.77H40v-1.77h4v3.77c0,1.11-.9,2-2,2Z",
    fill: filledColor
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42,12H6c-1.1,0-2,.89-2,2v20c0,1.11,.9,2,2,2H42c1.1,0,2-.89,2-2V14c0-1.11-.9-2-2-2ZM13.33,23.63c-1.45,0-2.62-1.17-2.62-2.62s1.17-2.62,2.62-2.62,2.62,1.17,2.62,2.62-1.17,2.62-2.62,2.62Zm22.91,5.4H17.79v-3h18.45v3Zm0-6.55H17.79v-3h18.45v3Z",
    fill: filledColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,36H6c-1.1,0-2-.89-2-2V14c0-1.11,.9-2,2-2H42c1.1,0,2,.89,2,2v20c0,1.11-.9,2-2,2Zm-34-4H40V16H8v16Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,44.9h-4v-1.77H8v1.77H4v-3.77c0-1.11,.9-2,2-2H42c1.1,0,2,.89,2,2v3.77Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,8.87H6c-1.1,0-2-.89-2-2V3.1h4v1.77H40v-1.77h4v3.77c0,1.11-.9,2-2,2Z",
    fill: outlineColor
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.79,
    y: 19.48,
    width: 18.45,
    height: 3,
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.79,
    y: 26.03,
    width: 18.45,
    height: 3,
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.33,
    cy: 21.01,
    r: 2.62,
    fill: outlineColor
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFeeds);
export default __webpack_public_path__ + "static/media/ico-feeds.146f23213b5b7b63a46b70cf9f2ed301.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;